import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { processInt } from '../../global';
import { getAdvices, initialData, BulkSaveAdvice } from '../../services/shipperadviceservice';
import { setLoading } from '../../redux/appSlice';
import { setGrid, setOriginalGrid, setReattempts, setCalltracks, setData, setFileLen, setFileName, setUploadedGrid, setUploadedGridStatus } from '../../redux/shipperAdviceSlice';
import UploadedGrid from './excelupload/grid';
import {calculateErrors} from './excelupload/calculateerrors';
import ExportExcelButton from "../../components/exportExcelButton";
import {exportSample} from './exportsample';
import { hasDuplicates } from '../../utils/util';
import { getMultipleSubAccountLocations } from '../../services/userservice';



const Form = ({ myWorker }) => {
    const dispatch = useDispatch();
    const state = useSelector(state => { return { appData: state.appData, shipperAdviceData: state.shipperAdviceData } });
    const { userInfo, loading, accounts,subaccounts } = state.appData;
    const {
        data,
        calltracks,
        reattempts,
        originalGrid,
        fileLen,
        uploadedGrid
    } = state.shipperAdviceData;

    const [subAccountsLocal, setSubAccountsLocal] = useState([]);
    const [locations, setLocations] = useState([]);

    const updateData = (key, val) => {
        const d = { ...data, [key]: val };
        dispatch(setData({ data: d }));
    };

    const fileRef = useRef(null);

    useEffect(() => {
        myWorker.onmessage = function (event) {

            const { sts, msg, dt } = event.data;

            fileRef.current.value = null;
            dispatch(setFileLen({ data: 0 }));
            dispatch(setFileName({ data: '' }));

            if (sts === 0) {

                const mappedDt = Array.isArray(dt) && dt.length > 0
                                ? dt
                                    .filter(e => originalGrid.some(o => o.cn === e.CN)) // only proceed if CN exists in originalGrid
                                    .map(e => {
                                        const data = originalGrid.find(o => o.cn === e.CN); // we already ensured there's a match

                                        const advice = calltracks.find(i => i.text.toUpperCase() === e.ShipperAdvice.toUpperCase());
                                        const reattempt = reattempts.find(i => i.text.toUpperCase() === e.ActionRequired.toUpperCase());

                                        return {
                                            ...data,
                                            newConsigneePhone: '',
                                            newConsigneeAddress: '',
                                            comments: e.Remarks,
                                            Remarks: e.Remarks,
                                            ShipperAdvice: e.ShipperAdvice,
                                            ActionRequired: e.ActionRequired,
                                            advice: advice ? Number(advice.value) : 0,
                                            reattemptReason: reattempt ? Number(reattempt.value) : 0
                                        };
                                    })
                                : [];
                
                const missingCNs = Array.isArray(dt) && dt.length > 0
                ? dt
                    .filter(e => !originalGrid.some(o => o.cn === e.CN)) // find CNs not in originalGrid
                    .map(e => e.CN)
                : [];
                
                if(mappedDt.length == 0 || missingCNs.length > 0) {
                    alert(`No active advice found against these consignments: ${missingCNs.join(', ')}`)
                    dispatch(setUploadedGrid({ data: [] }));
                } else {
                    dispatch(setUploadedGrid({ data: mappedDt }));
                }


            } else {
                alert(msg);
            }
            dispatch(setLoading({ data: false }));
        }
    }, []);

     const onUpload = async () => {
            dispatch(setLoading({ data: false }));
            const file = fileRef.current.files[0];
            const type = 1;
            myWorker.postMessage({ file: file, type: type});
    }

    useEffect(async () => {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        const init = async (id, data, source) => {
            dispatch(setLoading({ data: true }));
            const initdatars = await initialData(id, source);
            const advicesrs = await getAdvices(data, source);
            dispatch(setLoading({ data: false }));

            if (initdatars.sts == 0) {

                dispatch(setCalltracks({ data: initdatars.data.calltracks }));
                dispatch(setReattempts({ data: initdatars.data.reattempts }));
            }

            if (advicesrs.sts == 0) {
                dispatch(setGrid({ data: advicesrs.data }));
                dispatch(setOriginalGrid({ data: advicesrs.data }));
            }
        }

        if (accounts.length > 0) {

            const subAccs = subaccounts.filter(e => e.accountNo === accounts[0])

            setSubAccountsLocal(subAccs);

            const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: subaccounts.map(e => e.id)})

            if (locs.length > 0) {
                
                setLocations(locs);
                const d = { ...data, from: data.from ? data.from : null, to: data.to ? data.to : null, accountNo: accounts.join(), LocationID: locs.map(e => e.value)  };
                init(userInfo.id, d, source);
        
                //dispatch(setData({ data: { ...data, Account: [accounts[0]], subAccountId: [subAccs[0].id], LocationID: [+locs[0].value] } }));
            } else {
                const d = { ...data, from: data.from ? data.from : null, to: data.to ? data.to : null, accountNo: accounts[0] };
                init(userInfo.id, d, source);
        
                //dispatch(setData({ data: { ...data, Account: [accounts[0]], subAccountId: [subAccs[0].id] } }));
            }
        }
        return () => {
            source.cancel('Operation canceled by the user.');
        }
    }, []);


    // const validateExcel = () => {

    //     if (grid.filter(x => !x.Consignment).length > 0) {
    //         alert('Consignment No is required');
    //         return false;
    //     } else {
    //         const cns = grid.map(x => x.Consignment);
    //         if (hasDuplicates(cns)) {
    //             alert('Duplicate Consignment No are not allowed');
    //             return false;
    //         } 
    //     }
    // }

    const onSave = async () => {
            
        if (uploadedGrid.length == 0) {
            alert('Please upload advice first.');
            return;
        }

            const advices = uploadedGrid.map(x => {
                return {

                    cn: x.cn.substring(0, 50),
                    bookingDate: x.bookingDate,
                    ticketNo: x.ticketNo,
                    ticketDate: x.ticketDate,
                    createdOn: x.createdOn,
                    destinationBranch: x.destinationBranch,
                    pendingReason: x.pendingReason,
                    standardNote: x.standardNote,
                    callStatus: x.callStatus,
                    additionalRemarks: x.additionalRemarks,
                    kpi: x.kpi,
                    orderRefNo: x.orderRefNo,
                    comments: x.Remarks,
                    consignee: x.consignee,
                    consigneeContact: x.reattemptReason == 2 ? x.newConsigneePhone : x.consigneeContact,
                    consigneeAddress: x.reattemptReason == 2 ? x.newConsigneeAddress :  x.consigneeAddress,
                    tempAdvice: x.tempAdvice,
                    advice: x.advice,
                    reattemptReason: x.reattemptReason,
                    createdBy: x.createdBy,
                    callTrackName: x.callTrackName,
                    codAmount: x.codAmount,
                    showDetail: x.showDetail,
                    podStatus: x.podStatus,

                }
            });

            dispatch(setLoading({ data: true }));
            const rs = await BulkSaveAdvice(advices);
            dispatch(setLoading({ data: false }));
            if (rs.ok) {
                alert("Advice Saved");
                dispatch(setUploadedGrid({ data: [] }));
                dispatch(setUploadedGridStatus({ data: rs.data }));
                dispatch(setGrid({ data: [] }));
                dispatch(setOriginalGrid({ data: [] }));
            } else {
                alert(rs.msg);
            }
    }

    const onSearch = async () => {

        if (data.from && data.to) {
            if (Date.parse(data.from) > Date.parse(data.to)) {
                alert('Invalid Date');
                return;
            }
        }

        if (data.type === 2) {
            if (!data.cn && (!data.from || !data.to)) {
                alert('Enter Date Range or Consignment No');
                return;
            }
        }

        console.log(data.LocationID)
        if (data.LocationID.length === 0) {
            alert('Please select location.');
            return;
        }

        const d = { ...data, from: data.from ? data.from : null, to: data.to ? data.to : null };
        dispatch(setLoading({ data: true }));
        const advicesrs = await getAdvices(d);
        dispatch(setLoading({ data: false }));
        if (advicesrs.sts == 0) {
            if(advicesrs.data.length == 0) {
                alert('No Data Found')
            }

            dispatch(setGrid({ data: advicesrs.data }));
            dispatch(setOriginalGrid({ data: advicesrs.data }));
        }
    }


    useEffect(() => {
        dispatch(setGrid({ data: [] }));
        dispatch(setOriginalGrid({ data: [] }));
    }, [data.type])

    const ct = calltracks.map(e => e.text);
    const rt = reattempts.map(e => e.text);

    return <>
        {
            (calltracks && calltracks.length > 0) && (reattempts && reattempts.length > 0) &&
            <>
            <div>
                <div className="row pb-2">
                    <div className="col">
                        <label>Account</label>
                        <select className="form-select" multiple value={data.Account} onChange={async (e) => {
                            let value = Array.from(e.target.selectedOptions, option => option.value);
                            let d = { ...data, Account: value };
                            if (value && value.length > 0) {
                                const subAccs = subaccounts.filter(e => value.includes(e.accountNo.toUpperCase()));
                                setSubAccountsLocal(subAccs);
                                const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: [subAccs[0].id]})
                                d.subAccountId =  [subAccs[0].id];
                    
                                if (locs.length > 0) {
                                    d.LocationID = [+locs[0].value]
                                    setLocations(locs);
                                } else {
                                    d.LocationID = [];
                                    setLocations([]);
                                }
                            } else {
                                d.LocationID = [];
                                setLocations([]);
                            }
                            dispatch(setData({ data: d}));
                        }}>
                            {
                                accounts.map((x, index) => <option key={index} value={x}>{x}</option>)
                            }
                        </select>
                    </div>
    
                    <div className="col-lg">
                        <label>Sub Account</label>
                        <select className="form-select" value={data.subAccountId} multiple onChange={async (e) => {
                            const selectedOptions = Array.from(e.target.selectedOptions);
    
                            const accnos = selectedOptions
                                .map(option => option.getAttribute('data-accno'))
                                .filter(acc => acc && acc.trim() !== '');
                    
                            const uniqueAccnos = Array.from(
                                new Map(accnos.map(acc => [acc.toLowerCase(), acc])).values()
                            );
    
                            const val = Array.from(new Set(
                                selectedOptions
                                    .map(option => option.value)
                                    .filter(v => v && !isNaN(v))
                                    .map(v => parseInt(v))
                            ));
    
    
                            console.log("Filtered SubAccount IDs:", val);
                            console.log("Unique Account Nos (data-accno):", uniqueAccnos);
    
                            const d = { ...data, subAccountId: val, Account: uniqueAccnos };
                            if (val) {
                                //d.isCod = e.target[e.target.selectedIndex].getAttribute('data-iscod') === 'true';
                                const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: val})
                                console.log(locs);
                                if (locs && locs.length > 0) {
                                    
                                    d.LocationID = [+locs[0].value]
                                    setLocations(locs);
                                } else {
                                    setLocations([]);
                                    d.LocationID = []
                                }
                            } else {
                                setLocations([]);
                                //d.isCod = null;
                            }
                            dispatch(setData({ data: d}));
                        }}>
                            {
                                subAccountsLocal.map((x, index) => <option key={index} value={x.id} data-iscod={x.isCod} data-accno={x.accountNo}>{x.name}</option>)
                            }
                        </select>
                    </div>
    
                    <div className="col">
                        <label>Location</label>
                        <select className="form-select" multiple value={data.LocationID} onChange={async (e) => {
                            let val = Array.from(e.target.selectedOptions, option => +option.value);
                            dispatch(setData({ data: { ...data, LocationID: val }}));
                        }}>
                            {
                                locations.length > 0 && locations.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                            }
                        </select>
                    </div>
                </div>
            </div>
            <div className="row pb-2">
                {/* <div className="col">
                    <label>Accounts</label>
                    <select className="form-select" value={data.accountNo} onChange={e => updateData('accountNo', e.target.value)}>
                        {accounts.length > 1 && <option value={accounts.join(',')}>Select All</option>}
                        {
                            accounts.map((x, index) => <option key={index} value={x}>{x}</option>)
                        }
                    </select>
                </div> */}
                <div className="col">
                    <label>From</label>
                    <input type="date" className="form-control" value={data.from} onChange={e => updateData('from', e.target.value)} />
                </div>
                <div className="col">
                    <label>To</label>
                    <input type="date" className="form-control" value={data.to} onChange={e => updateData('to', e.target.value)} />
                </div>
                <div className="col">
                    <label>CN</label>
                    <input type="text" className="form-control" maxLength={15} onInput={processInt} value={data.cn} onChange={e => updateData('cn', e.target.value)} />
                </div>

                <div className="col">
                    <button type="button" className="btn btn-primary" style={{ marginTop: 20 }} onClick={onSearch}>Search</button>
                </div>


                <div className="col">
                    
                </div>
                
            </div>

            <div className="row pb-2">
                    
            </div>


            <div className="row pb-2">
                
                    <div className="col-lg-3">
                        <label>File</label>
                        <input
                            type='file'
                            ref={fileRef}
                            className='form-control'
                            onChange={(e) => {
                                dispatch(setFileName({ data: e.target.files.length > 0 ? e.target.files[0].name : '' }))
                                dispatch(setFileLen({ data: e.target.files.length }))
                            }}
                            style={{
                                height: '37px',
                                padding: '7.5px 13px'
                            }}
                        />
                    </div>

                    <div className="col-lg-2">
                    {
                        // data.type === 1 && originalGrid.length > 0 && <ExportSample grid={originalGrid} />
                         data.type === 1 && originalGrid.length > 0 && (
                                 <ExportExcelButton
                                   data={originalGrid}
                                   columns={exportSample}
                                   fileName="Ticket_Report"
                                   label="Export Data"
                                   className="btn btn-md btn-primary"
                                 />
                            )
                    }
                    </div>
            </div>

            <div className="sticky">
                <div id="errorDiv">
                    <div className="table table-sm table-bordered" style={{ color: 'red', marginTop: "30px" }}>
                        <div className='row' style={{ maxHeight: '200px', overflow: 'auto' }}>
                            {
                                calculateErrors(uploadedGrid, userInfo, ct, rt).length > 0 && <span style={{ fontSize: "20px" }}>Error Counts ({calculateErrors(uploadedGrid, userInfo, ct, rt).length}){" - "}
                                    {calculateErrors(uploadedGrid, userInfo, ct, rt)[0].fieldName}: {calculateErrors(uploadedGrid, userInfo, ct, rt)[0].error} {" "} <button type="button" className="btn btn-primary" onClick={() => {
                                        document.getElementById(`${calculateErrors(uploadedGrid, userInfo, ct, rt)[0].key}${calculateErrors(uploadedGrid, userInfo, ct, rt)[0].index + 1}`).focus({ focusVisible: true })
                                    }}>Go</button></span>}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg" style={{ textAlign: 'right' }}>
                        <button type="button" className="btn btn-primary" disabled={fileLen === 0} onClick={onUpload}>Upload</button>
                        <button type="button" className="btn btn-primary" style={{ marginLeft: 2 }} disabled={calculateErrors(uploadedGrid, userInfo, ct, rt).length > 0} onClick={onSave}>Save</button>
                    </div>
                </div>

                {uploadedGrid && uploadedGrid.length > 0 && <UploadedGrid grid={uploadedGrid} calltracks={calltracks} reattempts={reattempts} />}
            </div>
        </>
        }
    </>
}

export default Form;
